import RichTextEditor from 'react-rte'
import styled from 'styled-components'

export const StyledRichTextEditor = styled(RichTextEditor)``
